import { Card } from '../../../Common/Charts/Card';
import { number } from '../../../Common/Util/number';
import { useTradicionalGroupsChartsDataContext } from './hooks/useTradicionalGroupsChartsDataContext';

export const Indicators = () => {
    const { chartData } = useTradicionalGroupsChartsDataContext();

    return (
        <div className="w-100">
            <Card
                title="Total de Grupos Tradicionais"
                value={number.formatToBRNumber(
                    chartData?.indicators?.traditionalGroupsTotal || 0
                )}
            />
        </div>
    );
};
